import { Component, OnInit } from '@angular/core';
import { ModalService } from '@services/modal.service';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ReserveService } from '@services/reserve.service';
import { Reserve } from '@models/reserve.model';
import { AuthService } from '@services/auth.service';
import { Subscription } from 'rxjs';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-tab-reserves',
  templateUrl: './tab-reserves.component.html',
  styleUrls: ['./tab-reserves.component.scss'],
})
export class TabReservesComponent implements OnInit {
  public reserveList: Array<Reserve> = [];
  public selectedReserve: Reserve;

  // Radio
  public radioSel: any;
  public radioSelected: string;
  public sellerDocumentNumber = '0';
  public sellerDocumentType = 'C';
  public totalPages = 1;
  public pageLimit = 10;
  public page = 1;
  private eventsSubscription: Subscription;

  constructor(
    private auth: AuthService,
    public modal: ModalService,
    public router: Router,
    public reserveService: ReserveService,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit() {
    this.loadReserves();
  }

  loadReserves() {
    //console.log('loadReserves!!!!!!');
    this.spinner.show();
    this.reserveService
      .getLegacyReserves(
        this.page.toString(),
        this.pageLimit.toString(),
        this.sellerDocumentNumber,
        this.sellerDocumentType,
      )
      .subscribe(
        (reserveList: Array<Reserve>) => {
          this.reserveList = reserveList;
          this.totalPages =
            reserveList.length > 0
              ? Math.ceil(
                parseInt(reserveList[0].numberOfRecords, 10) / this.pageLimit
              )
              : 1;
          this.spinner.hide();
        },
        (err) => {
          this.spinner.hide();
          if (err.status === 401) {
            this.modal.show("modalLogoutErrorComponent");
          } else {
            Swal.fire({
              type: 'error',
              title: 'Error:',
              text: `Por favor intente más tarde. ${err.error.id_tx ? err.error.id_tx : ''}`,
            });
          }
        }
      );
  }

  pageSelected(page: any) {
    this.page = page.currentPage;
    this.loadReserves();
  }

  onSearch(searchText: string) {
    this.page = 1;
    this.sellerDocumentNumber = searchText ? searchText : '0';
    this.selectedReserve = null;
    this.loadReserves();
  }
  checkSelectedReserve(reserve: Reserve) {
    this.selectedReserve = reserve;
  }
  goTransaction() {
    if (this.selectedReserve) {
      (window as any).gtag('event', 'inicio-transaccion', {
        event_category: 'listado-reservas',
        event_label: `${this.auth.identity.userInfo.documentType}:${this.auth.identity.userInfo.document}:1;${this.auth.identity.username}`,
      });
      this.router.navigateByUrl(
        // tslint:disable-next-line:max-line-length
        `/pages/transacciones/transaccion-individual/${this.selectedReserve.documentType}/${this.selectedReserve.document}/${this.selectedReserve.queryCode}/${this.selectedReserve.reservationCode}`
      );
    }
  }
}
